import { ClassQnpMRequestModel, ClassRequestModel, SubjectClassReqModel } from "@boi/shared-models";
import { Injectable } from "@nestjs/common";
import { DataSource, Repository } from "typeorm";
import { ClassEntity } from "../../entities/class";
import { LanguageEntity } from "../../entities/language";
import { Subject } from "../../entities/subject";
import { ChapterWiseModel } from "../entities/chapter-wise-model.entity";
import { QuestionPaperModal } from "../entities/question-paper-modal";
import { SectionWiseModel } from "../entities/section-wise-model.entity";

@Injectable()
export class ModelPaperRepo extends Repository<QuestionPaperModal> {
    constructor(private dataSource: DataSource) {
        super(QuestionPaperModal, dataSource.createEntityManager());
    }

    async getAllModelPaperData(req: ClassRequestModel) {
        const classData = await this.createQueryBuilder('qpm')
            .select(`qpm.id,qpm.subject,qpm.language,qpm.blue_print_name as bluePrintName,qpm.total_questions as totalQuestions,class.class,subject.subject as subjName,language.language as languageName,qpm.time_limit as timeLimit,qpm.tagline as tagline,qpm.part_name as partName,qpm.marks as marks,qpm.no_of_sections as noOfSections`)
            .leftJoin(ClassEntity, 'class', 'class.id=qpm.class')
            .leftJoin(Subject, 'subject', 'subject.id=qpm.subject')
            .leftJoin(LanguageEntity, 'language', 'language.id=qpm.language')
            .where(`qpm.class='${req.classId}'`)
        const data = await classData.getRawMany();
        return data;
    }

    async getModelPaperData(req: ClassQnpMRequestModel) {
        const classData = await this.createQueryBuilder('qpm')
            .select(`qpm.total_questions as totalQuestions,qpm.instructions,class.class as className,subject.subject,language.language,qpm.time_limit as timeLimit,qpm.tagline as tagline,qpm.part_name as partName,qpm.marks as marks,qpm.no_of_sections as noOfSections,qpm.class as classId,qpm.subject as subjectId`)
            .leftJoin(ClassEntity, 'class', 'class.id=qpm.class')
            .leftJoin(Subject, 'subject', 'subject.id=qpm.subject')
            .leftJoin(LanguageEntity, 'language', 'language.id=qpm.language')
            .where(`qpm.class='${req.classId}' and qpm.id='${req.qnpMId}'`)
        const data = await classData.getRawOne();
        return data;
    }

    async getSectionWiseModelPaperData(req: ClassQnpMRequestModel) {
        const sections = await this.dataSource.getRepository(SectionWiseModel).find({
            where: { qnpModel: { id: req.qnpMId } },
            relations: ['chapterWiseModel', 'chapterWiseModel.chapter']
        });

        return sections.map(section => ({
            ...section,
            mandatory_qns: section.mandatoryQns,
            each_qn_weightage: section.eachQnWeightage,
            no_of_qns: section.noOfQns,
            chapterWiseData: section.chapterWiseModel.map(c => ({
                id: c.id,
                chapter: c.chapter?.id,
                noOfQns: c.noOfQns,
                subAbilityId: c.subAbilityId
            }))
        }));
    }

    async getModelPaperDataBySubjectRepo(req: SubjectClassReqModel) {
        const classData = this.createQueryBuilder('qpm')
            // .select(`qpm.*,section.id as sectionId,section.marks as sectionMarks,section.note as sectionNote,section.no_of_qns as sectionNoOfQns,section.mandatory_qns as sectionMandatoryQns,section.each_qn_weightage as sectionEachQnWeightage,chapter.id as chapterId,chapter.chapter as chapter,chapter.no_of_qns as chapterNoofqns`)
            .leftJoinAndSelect('qpm.sectionsWiseModel','sectionWiseModel')
            .leftJoinAndSelect('sectionWiseModel.chapterWiseModel','chapterWiseModel')
            .leftJoinAndSelect('chapterWiseModel.chapter','chapter')
            .where(`qpm.class='${req.classId}' and qpm.subject='${req.subject}'`)
            .orderBy('sectionWiseModel.sectionNo', 'ASC')
        const data = await classData.getMany();
        console.log(data,"d----------")
        return data;
    }
}